// extracted by mini-css-extract-plugin
export var acceptButton = "_3k-5";
export var fullContent = "_3k-4";
export var link = "_3k-6";
export var linkIcon = "_3k-7";
export var sideContent = "_3k-3";
export var sideImage = "_3k-2";
export var sideImageWrapper = "_3k-1";
export var splitLayout = "_3k-0";